"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useQuestionAndProperty;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

function useQuestionAndProperty(_ref) {
  var questionId = _ref.questionId,
      questionsMap = _ref.questionsMap,
      properties = _ref.properties;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      question = _useState2[0],
      setQuestion = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      property = _useState4[0],
      setProperty = _useState4[1];

  (0, _react.useEffect)(function () {
    var tmpQuestion = questionsMap.get(questionId);

    if (!tmpQuestion) {
      return;
    }

    if (!tmpQuestion.objectType || !tmpQuestion.propertyName) {
      setQuestion(tmpQuestion);
      return;
    }

    var tmpProperty = properties.getIn([tmpQuestion.objectType, 'properties', tmpQuestion.propertyName]);
    var tmpQuestionWithProperty = tmpQuestion.setProperty(tmpProperty);
    setQuestion(tmpQuestionWithProperty);
    setProperty(tmpProperty);
  }, [questionId, questionsMap, properties]);
  return {
    question: question,
    setQuestion: setQuestion,
    property: property,
    setProperty: setProperty
  };
}

module.exports = exports.default;